
import { defineComponent } from 'vue';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonMenuButton, IonButton, IonIcon } from '@ionic/vue';
import { refreshOutline } from 'ionicons/icons';
import { cachedIndex, DocSummary, isUpdatedSinceSeen, refreshDocsIndex } from '../../docsHelp';

export default defineComponent({
  name: 'HelpCenter',
  components: { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonMenuButton, IonButton, IonIcon },
  data() {
    return { docs: [] as DocSummary[], search: '', loading: false, refreshOutline };
  },
  computed: {
    groups(): { category: string; docs: DocSummary[] }[] {
      const term = this.search.trim().toLowerCase();
      const byCategory: Record<string, DocSummary[]> = {};
      for (const doc of this.docs) {
        if (term && !(doc.title + ' ' + (doc.summary || '')).toLowerCase().includes(term)) {
          continue;
        }
        (byCategory[doc.category] = byCategory[doc.category] || []).push(doc);
      }
      return Object.keys(byCategory).sort().map(category => ({ category, docs: byCategory[category] }));
    },
  },
  created() {
    this.docs = cachedIndex()?.docs || [];
    this.load(false);
  },
  methods: {
    async load(force: boolean) {
      this.loading = true;
      const index = await refreshDocsIndex(force);
      this.docs = index?.docs || [];
      this.loading = false;
    },
    isUpdated(doc: DocSummary) {
      return isUpdatedSinceSeen(doc.slug, doc.version);
    },
  },
});
